import React, { useEffect, useState } from 'react';
import Selection from '../../selection';

function Default(props) {
    const [display, setDisplay] = useState(displayPage())

    useEffect(() => {
        if (props.page === 35 && props.store.default_date !== undefined && props.store.default_amount !== undefined && props.store.default_settled !== undefined && props.store.default_for_mobile !== undefined) {
            let default_date = props.store.default_date
            let default_amount = props.store.default_amount
            let default_settled = props.store.default_settled
            let default_for_mobile = props.store.default_for_mobile
            delete props.store.default_date
            delete props.store.default_amount
            delete props.store.default_settled
            delete props.store.default_for_mobile
            props.setValue({ ...props.store, defaults: [...props.store.defaults, {default_date: default_date, default_amount: default_amount, default_settled: default_settled, default_for_mobile: default_for_mobile }]})
        }
        setDisplay(displayPage())
    }, [props.page, props.store])

    function remove_default(i) {
        props.store.defaults.splice(i, 1)
        props.setValue({...props.store, defaults: props.store.defaults})
    }

    function displayPage() {
        switch (props.page) {
            case 30:
                return (
                    <Selection prev={props.prev} setPrev={props.setPrev} store={props.store} setPage={props.setPage} page={{
                        heading: "Have you ever defaulted?",
                        info: {
                            id: "default_modal",
                            text: "What is a default?",
                            content: "A default means that you failed to repay a debt, so it negatively affects your credit score – causing it to go down.",
                            content2: "Lenders don’t like defaults because it’s a signal to them that you’ve struggled to repay debts in the past. And this means you’re considered a ‘high-risk’ borrower."
                        },
                        buttons: {
                            "Yes": {
                                value: "YES",
                                next: 31
                            },
                            "No": {
                                value: "NO",
                                next: 36
                            }
                        }
                    }} id={"had_a_default"} setValue={(e) => props.setValue({ ...props.store, had_a_default: e, defaults: [] })} />
                )

            case 31:
                return (
                    <Selection prev={props.prev} setPrev={props.setPrev} store={props.store} setPage={props.setPage} page={{
                        heading: "When was your most recent default?",
                        input: {
                            type: "month",
                            placeholder: "MM - YYYY",
                            id: "default_date",
                            min: 7,
                            next: 32
                        }
                    }} id={"default_date"} setValue={(e) => props.setValue({ ...props.store, default_date: e })} />
                )

            case 32:
                return (
                    <Selection prev={props.prev} setPrev={props.setPrev} store={props.store} setPage={props.setPage} page={{
                        heading: "How much was the default for?",
                        input: {
                            type: "number",
                            placeholder: "10000",
                            id: "default_amount",
                            next: 33
                        }
                    }} id={"default_amount"} setValue={(e) => props.setValue({ ...props.store, default_amount: e })} />
                )

            case 33:
                return (
                    <Selection prev={props.prev} setPrev={props.setPrev} store={props.store} setPage={props.setPage} page={{
                        heading: "When was the default settled?",
                        input: {
                            type: "month",
                            placeholder: "MM - YYYY",
                            id: "default_settled",
                            min: 7,
                            next: 34
                        },
                        sub_button: {
                            "Or mark this Default as not yet satisfied": {
                                value: "ONGOING",
                                next: 34
                            }
                        }
                    }} id={"default_settled"} setValue={(e) => props.setValue({ ...props.store, default_settled: e })} />
                )

            case 34:
                return (
                    <Selection prev={props.prev} setPrev={props.setPrev} store={props.store} setPage={props.setPage} page={{
                        heading: "Was the default for a mobile phone?",
                        buttons: {
                            "Yes": {
                                value: "YES",
                                next: 35
                            },
                            "No": {
                                value: "NO",
                                next: 35
                            }
                        }
                    }} id={"default_for_mobile"} setValue={(e) => props.setValue({ ...props.store, default_for_mobile: e })} />
                )

            case 35:
                return (
                    <Selection prev={props.prev} setPrev={props.setPrev} store={props.store} setPage={props.setPage} page={{
                        heading: "Please list all defaults since May 2019",
                        info: {
                            id: "default_modal_2",
                            text: "What is a default?",
                            content: "A default means that you failed to repay a debt, so it negatively affects your credit score – causing it to go down.",
                            content2: "Lenders don’t like defaults because it’s a signal to them that you’ve struggled to repay debts in the past. And this means you’re considered a ‘high-risk’ borrower."
                        },
                        collection: {
                            type: "default",
                            add: 31
                        },
                        next: 36
                    }} id={"default_collection"} setValue={(e) => {}} remove={(e) => remove_default(e)} />
                )
        }
    }

    return (
        <div>
            {display}
        </div>
    );
}

export default Default;